export default () => ({
  componentName: 'cell-image',
});
